import { render, staticRenderFns } from "./start-call-widget.vue?vue&type=template&id=115d5a38&"
import script from "./start-call-widget.vue?vue&type=script&lang=js&"
export * from "./start-call-widget.vue?vue&type=script&lang=js&"
import style0 from "./start-call-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
